import { TableDataSource } from 'common/table/table-data-source';
import { AggregatedProduct, CustomEnumFilter, ViewService } from 'api';
import { PagedResultWithCustomFilter, PageLoadParams } from 'common/table/paged-result.interface';
import { EMPTY, Observable, tap } from 'rxjs';
import { inject, signal } from '@angular/core';

export class AggregatedProductsDataSource extends TableDataSource<AggregatedProduct> {
  private viewService = inject(ViewService);

  private _manufacturerId?: number;

  customEnumFilters = signal<CustomEnumFilter[]>([]);

  set manufacturerId(value: number) {
    this._manufacturerId = value;
  }

  protected fetchPage(
    pageLoadParams: PageLoadParams,
  ): Observable<PagedResultWithCustomFilter<AggregatedProduct>> {
    if (this._manufacturerId === undefined) {
      return EMPTY;
    }

    const additionalParams = pageLoadParams.additionalParams || {};
    return this.viewService
      .getAggregatedProducts(
        this._manufacturerId,
        additionalParams['declarationStatus'],
        additionalParams['filterText'],
        additionalParams['intakeType'],
        pageLoadParams.page,
        pageLoadParams.pageSize,
        pageLoadParams.sortBy,
        pageLoadParams.sortDirection,
      )
      .pipe(
        tap((result) => {
          this.customEnumFilters.set(result.customEnumFilters || null);
        }),
      );
  }
}
